import { t } from 'i18next'

export enum ShowingSuggestion {
  TENANT_SHOWS = 'tenant_shows',
  PROPERTY_COMPANY_GROUP_SHOWS = 'property_company_group_shows',
}

export const useShowingSuggestions = () => ({
  showingSuggestions: [
    {
      id: ShowingSuggestion.TENANT_SHOWS,
      label: t('terminateContract:showingSuggestions.tenant'),
    },
    {
      id: ShowingSuggestion.PROPERTY_COMPANY_GROUP_SHOWS,
      label: t('terminateContract:showingSuggestions.propertyCompanyGroup'),
    },
  ],
})
